import { DictionaryUser } from "etl/types";

export const sortUser = ((a: DictionaryUser, b: DictionaryUser) => {
	// Comparaison des lastNames
	const lastNameComparison = a.libelle_audio.localeCompare(b.libelle_audio);

	// Sinon, on retourne le résultat de la comparaison des lastNames
	return lastNameComparison;
});
